import { MutationFunction } from '@tanstack/react-query';
import { EFolderMappingData } from './getMappingsByType';
import { isMockServices } from 'src/utils';
import mock from '../utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

const upsertMappingsByType: MutationFunction<
  boolean,
  { type: string; mapping: EFolderMappingData }
> = async (args) => {
  if (isMockServices()) return await mock(true);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{
    success: boolean;
    mapping: EFolderMappingData;
  }>(`/mappings/${args.type}`, {
    method: 'POST',
    body: {
      filename: args.mapping.filename,
      document_type: args.mapping.document_type,
      target_folder: args.mapping.target_folder,
    },
  });
  if (response.data) {
    return response.data.success;
  }
  throw new Error('Failed to upsert mappings by type');
};

export default upsertMappingsByType;
